import { motion } from "framer-motion";
import { fadeUp, stagger } from "../animations";

const Project = ({ title, tech, desc }) => (
  <motion.div
    variants={fadeUp}
    whileHover={{ y: -8 }}
    className="bg-gradient-to-br from-[#1b254b] to-[#050814] p-6 rounded-xl border border-blue-400/40"
  >
    <h3 className="font-semibold">{title}</h3>
    <p className="text-sm text-gray-400 mt-1">{tech}</p>
    <p className="text-gray-400 text-sm mt-3">{desc}</p>
  </motion.div>
);

export default function Projects() {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={stagger}
      className="max-w-6xl mx-auto px-6 py-16"
    >
      <h2 className="text-2xl font-semibold mb-8 text-yellow-300">
        Major Projects
      </h2>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <Project
          title="AI-Powered OCR System"
          tech="Python · Flask · ML · OCR"
          desc="Extracts text from images and documents with ML-powered OCR."
        />
        <Project
          title="NLP Spam Detection"
          tech="Python · NLP · ML"
          desc="Classifies messages as spam or normal using ML models."
        />
        <Project
          title="Video-to-Text Transcription"
          tech="Python · Speech · ML"
          desc="Automated audio/video transcription pipeline."
        />
        <Project
          title="ERP Admin Dashboard"
          tech="Flask / PHP · MySQL"
          desc="Role-based admin dashboards with analytics and reporting."
        />
        <Project
          title="Flutter + Flask App"
          tech="Flutter · Flask · APIs"
          desc="Cross-platform mobile app integrated with backend APIs."
        />
        <Project
          title="Student ML Project Suite"
          tech="Mentoring · ML"
          desc="Guided 50+ students to complete real-world ML projects."
        />
      </div>
    </motion.section>
  );
}
